export type { TProfileLead, TProfileLeadStatus, TProfileLeadDetail } from '~/types/b2b'

export const PROFILE_LEAD_STATUS_LABELS: Record<string, string> = {
  new: 'Новая',
  bank_responded: 'Есть ответ',
  accepted_by_user: 'Принята',
  cancelled_by_user: 'Отменена',
  rejected_by_bank: 'Отклонён',
}

export const PROFILE_LEAD_STATUS_CLASSES: Record<string, string> = {
  new: 'bg-blue-100 text-blue-700',
  bank_responded: 'bg-yellow-100 text-yellow-700',
  accepted_by_user: 'bg-green-100 text-green-700',
  cancelled_by_user: 'bg-gray-100 text-gray-600',
  rejected_by_bank: 'bg-red-100 text-red-700',
}

export const PROFILE_LEAD_STATUS_FALLBACK_CLASS = 'bg-gray-100 text-gray-600'

export const getProfileLeadStatusClass = (status: string): string =>
  PROFILE_LEAD_STATUS_CLASSES[status] ?? PROFILE_LEAD_STATUS_FALLBACK_CLASS

export const getProfileLeadStatusLabel = (status: string): string =>
  PROFILE_LEAD_STATUS_LABELS[status] ?? status
